import { Core, Decorative } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { HeroSection } from "@faire/retailer/views/careers/__internal__/components/HeroSection";

export const BelongingHeroSection: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const headerText = strictLocalize({
    defaultMessage: "Celebrating diversity",
    description: {
      text: "eyebrow font for the hero section of careers Belonging at faire page",
      img: "https://cdn.faire.com/fastly/6502181f1abdaa2e783cf91da8010083f795d7cad92d8e8a3fd55cb94f3659c3.png",
    },
  });
  const eyebrowText = strictLocalize({
    defaultMessage: "Belonging At Faire",
    description: {
      text: "eyebrow font for the hero section of careers Belonging at faire page",
      img: "https://cdn.faire.com/fastly/6502181f1abdaa2e783cf91da8010083f795d7cad92d8e8a3fd55cb94f3659c3.png",
    },
  });
  const IMAGES = [
    "https://cdn.faire.com/fastly/b7ccc6bf09875cdb0853bfdb936c8a9f7f946e4d3e28371c058e53d85ae65759.png",
  ];

  const { isDesktopAndAbove } = useViewport();

  return (
    <HeroSection
      eyebrowText={eyebrowText}
      eyebrowColor={Core.icon.inverse}
      heroImages={IMAGES}
      backgroundColor={Decorative.shade.yellow}
    >
      <MobileTextWidth
        variant={{
          mobileAndAbove: "displayMSerifRegular",
          desktopAndAbove: "displayLSerifRegular",
        }}
        color={Core.text.inverse}
      >
        {headerText}
      </MobileTextWidth>
      <Spacer height={isDesktopAndAbove ? "3x" : "2x"} />
      <MobileTextWidth
        color={Core.text.inverse}
        variant={{
          mobileAndAbove: "paragraphSansRegular",
          desktopAndAbove: "subheadingSansMedium",
        }}
      >
        <StrictLocalMsg
          defaultMessage="We’re committed to building diverse teams and supporting all of our communities at Faire."
          description={{
            text: "Line to show how faire is committed to building and supporting diversity",
          }}
        />
      </MobileTextWidth>
    </HeroSection>
  );
};

const MobileTextWidth = styled(Typography)`
  ${responsiveMediaQueries.mobile} {
    max-width: ${getSpacing(230)};
  }
`;
